jQuery(document).ready(function($) {
    $(".bloc_bouton").each(function(index) {
        var parent = $(this);
    });
});
